import { c as _c } from "react/compiler-runtime";
import { HiChevronRight } from 'react-icons/hi2';
export const BreadcrumbSeparator = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <li role="presentation" aria-hidden="true"><HiChevronRight className="size-4" aria-hidden="true" /></li>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};